module.exports = __webpack_public_path__ + "2386a273b52bd0149a3f8404cce27a5d.pdf";